export default function DenialListFlag({ width = 12, height = 12, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 10 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.625001 0H9.58334C9.74118 0 9.88543 0.0891676 9.95601 0.230328C10.0266 0.371488 10.0113 0.54041 9.91668 0.666667L7.60418 3.75L9.91668 6.83334C10.0113 6.9596 10.0266 7.12852 9.95601 7.26968C9.88543 7.41084 9.74118 7.50001 9.58334 7.50001H1.25V11.0417C1.25 11.3868 0.970176 11.6667 0.625001 11.6667C0.279825 11.6667 0 11.3868 0 11.0417V0.625001C0 0.279822 0.279825 0 0.625001 0Z'
        fill='#D93F4C'
      />
    </svg>
  );
}
